import { render } from "./StampaPrenotati.vue?vue&type=template&id=0ddc3b96&scoped=true"
import script from "./StampaPrenotati.vue?vue&type=script&lang=js"
export * from "./StampaPrenotati.vue?vue&type=script&lang=js"

import "./StampaPrenotati.vue?vue&type=style&index=0&id=0ddc3b96&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ddc3b96"]])

export default __exports__